export default "__VITE_ASSET__BrYv34B3__"